import { Theme } from '@mui/material';
import { makeStyles } from '@mui/styles';
import bgPattern from '../../../../Assets/images/BackgroundPatternTerms.svg';

export const useStyles = makeStyles((theme: Theme) => ({
  hero: {
    background: `linear-gradient(180deg, #111029, #28255E)`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    color: '#fff',
    padding: '180px 20px 60px 20px',
    textAlign: 'center',
    '&::before': {
      content: '""',
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundImage: `url(${bgPattern})`,
      backgroundRepeat: 'repeat',
      backgroundPosition: 'top',
      backgroundSize: '100%',
      zIndex: 1,
    },
    [theme.breakpoints.down('md')]: {
      padding: '150px 20px 30px 20px',
    }
  },
  heroTitle: {
    fontFamily: 'Figtree',
    fontSize: '32px !important',
    fontWeight: '600 !important',
    lineHeight: '116%',
    color: 'var(--Colors-Neutral-100, #FFF)',
    [theme.breakpoints.down('md')]: {
      fontSize: '26px !important',
    }
  },
  contentContainer: {
    width: '80%',
    padding: '60px 60px 30px 60px !important',
    color: '#000',
    [theme.breakpoints.down('md')]: {
width: '90%',  
    padding: '40px 20px 30px 20px !important',
  }
  },
  section: {
    marginBottom: '20px',
    
  },
  title: {
    fontWeight: '600 !important',
    fontSize: '18px !important',
    marginBottom: '20px !important',
    [theme.breakpoints.down('md')]: {
    marginBottom: '10px !important',
  }
  },
  content: {
    fontSize: '14px',
    fontWeight: '500',
    lineHeight: 1.7,
  },
}));
